import React from "react";

export default function Error404() {

    ///TODO need to be fixed later
    return(
        <div/>
    );
}